import React from "react";
import "../src/Styles/Pages/pmorderprocessing.scss";
import withAppData from "../src/HOC/withAppData";

const DriverReconStock = (props) => {
  return (
    <div className="pm-recon-stock">
      <div className="pm-recon-stock-head">
        <div className="pm-recon-stock-head-top">
          <p>Delivery Quantity</p>
          <span>
            {!!props.driverReconcilationDetails
              ? props.driverReconcilationDetails.deliveredQuantity || 0
              : 0}
            ctn
          </span>
        </div>
        <div className="pm-recon-stock-head-top">
          <p>Remaining Quantity</p>
          <span>
            {!!props.driverReconcilationDetails
              ? props.driverReconcilationDetails.remaining || 0
              : 0}
            ctn
          </span>
        </div>
      </div>
      {(!!props.driverReconcilationDetails
        ? !!props.driverReconcilationDetails.itemDetails
          ? props.driverReconcilationDetails.itemDetails
          : []
        : []
      ).map((item, index) => (
        <div className="pm-recon-stock-card" key={index}>
          <p>{item.itemName || ""}</p>
          <div className="pm-recon-stock-card-list">
            <p>
              <span className="light">Picked quantites:</span>{" "}
              {item.picked || 0}
            </p>
            <p>
              <span className="light">Quantity remaining:</span>{" "}
              {item.remaining || 0}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default withAppData(DriverReconStock);
